import { useState } from "react";
import { Plus } from "lucide-react";
import { Shimmer } from "../Shimmer/Shimmer";
import { CheckTable } from "../CheckTable/CheckTable";
import { CheckModal } from "../CheckModal/CheckModal";
import { useCheckList } from "../../hooks/useCheckList";
import "../RequestsSection/RequestsSection.scss";

export const CheckSection = () => {
  const [createOpen, setCreateOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const { data, loading, error, refetch, applySavedCheck } = useCheckList();

  return (
    <section className="requests-section requests-section--embedded" aria-label="Проверки">
      <div className="requests-section-header">
        <h1 className="requests-section-title">Проверки</h1>
        <button
          type="button"
          className="requests-section-create-btn"
          onClick={() => setCreateOpen(true)}
        >
          <Plus size={20} />
          <span>Создать проверку</span>
        </button>
      </div>

      {loading ? (
        <Shimmer rows={5} />
      ) : error ? (
        <div className="requests-section-error">
          <p className="requests-section-error__text">{error}</p>
          <button type="button" className="requests-section-error__retry" onClick={refetch}>
            Повторить
          </button>
        </div>
      ) : (
        <CheckTable data={data} onRowClick={setSelectedId} />
      )}

      {createOpen && (
        <CheckModal onClose={() => setCreateOpen(false)} onSaved={applySavedCheck} />
      )}

      {selectedId && (
        <CheckModal
          checkId={selectedId}
          onClose={() => setSelectedId(null)}
          onSaved={applySavedCheck}
        />
      )}
    </section>
  );
};
